/*
 *
 * AppSettings reducer
 *
 */
import produce from 'immer';
export var initialState = {
    loading: false,
    error: false,
    loadingUpdate: false,
    errorUpdate: false,
    loadingDelete: false,
    errorDelete: false,
    errorDevPlan: false,
    errorSharedDelete: false,
    cloneSuccess: false,
    updateSuccess: false,
    appDataLoading: false,
    appDataError: false,
    appCheckLoading: false,
    appCheckError: false,
    appData: {
        push: 0,
        builds: 0,
        publishing_certificates: 0,
        push_tokens: 0,
        analytics: 0,
    },
    checkData: [],
};
function appSettingsReducer(currentState, action) {
    if (currentState === void 0) { currentState = initialState; }
    return produce(currentState, function (state) {
        switch (action.type) {
            case 'AppSettings/CLONE_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'AppSettings/CLONE_SUCCESS':
                state.loading = false;
                state.error = false;
                break;
            case 'AppSettings/CLONE_FAIL':
                state.loading = false;
                state.error = true;
                break;
            case 'AppSettings/UPDATE_VERSION_REQUEST':
                state.loadingUpdate = true;
                state.errorUpdate = false;
                state.updateSuccess = false;
                break;
            case 'AppSettings/UPDATE_VERSION_SUCCESS':
                state.loadingUpdate = false;
                state.errorUpdate = false;
                state.updateSuccess = true;
                break;
            case 'AppSettings/UPDATE_VERSION_FAILURE':
                state.loadingUpdate = false;
                state.errorUpdate = true;
                state.updateSuccess = false;
                break;
            case 'AppSettings/DELETE_REQUEST':
                state.loadingDelete = true;
                state.errorDelete = false;
                break;
            case 'AppSettings/DELETE_SUCCESS':
                state.loadingDelete = false;
                state.errorDelete = false;
                break;
            case 'AppSettings/DELETE_FAILURE':
                state.loadingDelete = false;
                state.errorDelete = true;
                break;
            case 'AppSettings/DELETE_DEVPLAN_FAILURE':
                state.loadingDelete = false;
                state.errorDevPlan = true;
                break;
            case 'AppSettings/DELETE_SHARED_APP_FAILURE':
                state.loadingDelete = false;
                state.errorSharedDelete = true;
                break;
            case 'AppSettings/GET_APP_DATA_SUCCESS':
                if ('appData' in action) {
                    state.appData = action.appData;
                }
                state.appDataLoading = false;
                state.appDataError = false;
                break;
            case 'AppSettings/CHECK_DELETE_REQUEST':
                state.appCheckLoading = true;
                state.appCheckError = false;
                break;
            case 'AppSettings/CHECK_DELETE_SUCCESS':
                state.checkData = action.checkData;
                state.appCheckLoading = false;
                state.appCheckError = false;
                break;
            case 'AppSettings/CHECK_DELETE_FAILURE':
                state.appCheckLoading = false;
                state.appCheckError = true;
                break;
            case 'AppSettings/GET_APP_DATA_REQUEST':
                state.appDataLoading = true;
                state.appDataError = false;
                break;
            case 'AppSettings/GET_APP_DATA_FAILURE':
                state.appDataLoading = false;
                state.appDataError = true;
                break;
            case 'AppSettings/CLEAR_APP_DATA_REQUEST':
                state.appDataLoading = true;
                state.appDataError = false;
                break;
            case 'AppSettings/CLEAR_APP_DATA_SUCCESS':
                state.appDataLoading = false;
                state.appDataError = false;
                break;
            case 'AppSettings/CLEAR_APP_DATA_FAILURE':
                state.appDataLoading = false;
                state.appDataError = true;
                break;
            default:
                break;
        }
    });
}
export default appSettingsReducer;
